import { mapGetters } from 'vuex'
import help from '@/utils/help'
import zip from '@/utils/zip'
import { openAcademic } from '@/api/open'
import reportDetail from './report-detail'

import {
  PRE_DECISION,
  FIRST_DECISION,
  FINAL_DECISION,
  DECISION_STATUS
} from '@/utils/dict'
import { getUploadConfig } from '@/utils/upload'
import check from '@/utils/check'
// import SendEmail from '../../editorial-office/manuscripts/dialog/send-email.dialog'
import customerReviewQuestion from '@/components/question.vue'

export default {
  components: { reportDetail, customerReviewQuestion },
  data() {
    return {
      // 取回数据
      reviewsResponse: {}, // 审稿人信息
      journalResponse: {}, // 稿件信息
      showVersion1: true,
      showDecision1: false,
      // 填写数据 外编信息
      reviews: {
        // reviewerList: [
        //   {
        //     firstName: '',
        //     lastName: '',
        //     email: ''
        //   }
        // ]
        decisionStatus: ''
      },
      //
      rules: {},
      reviewerFileList: [],
      isMoreText: false,
      isMoreText1: false,
      termList: PRE_DECISION,
      termListStatus: DECISION_STATUS,
      routeStatu: '',
      statu: 1,
      type: '',
      parmas: {
        editorNotes: ''
      },
      isView: false,
      showExternal: false,
      loading: false,
      showEditor: false,
      showAuthor: false,
      code: '',
      decisionType: '',
      showReport: false,
      activeData: {},
      activeKey: []
    }
  },
  mounted() {
    this.renderList()
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      manuscriptType: 'getManuscriptType',
      country: 'getCountry',
      title: 'getTitle',
      user: 'getUser',
      domain: 'getDomain',
      degree: 'getDegree'
    })
  },
  watch: {
    // 监听相同路由下参数变化的时候，从而实现异步刷新
    $route() {
      this.renderList()
    }
  },
  methods: {
    getRules() {
      this.rules = {
        authorNotes: [
          {
            required: true,
            message: 'Comments to Author' + this.LANGUAGE[this.language].noEmpty
          }
        ]
        // email: [
        //   {
        //     type: 'email',
        //     message: 'Email' + this.LANGUAGE[this.language].inputCorrectEmail
        //   }
        // ]
      }
    },

    renderList() {
      this.code = this.$route.query.decisionKey
      this.decisionType = this.$route.query.decisionType
      if (
        !['pre_check', 'final_check', 'first_check'].includes(this.decisionType)
      ) {
        this.$router.push(`/email-url/404`)
      }
      const routeName = this.$route.name
      switch (routeName) {
        case '/email-url/academic-agree':
          this.isView = false
          break
        case '/email-url/academic-agree/detail':
          this.isView = true
          break
      }
      this.getData()
      this.getRules()
      if (this.statu === 1 || this.statu === 2) {
        this.rules.authorNotes[0].required = false
      }
    },

    // 获取数据
    async getData() {
      switch (this.decisionType) {
        case 'pre_check':
        case 'PRE_CHECK':
          this.statu = 0
          this.termList = PRE_DECISION
          this.type = 'PRE_CHECK'
          break
        case 'first_check':
        case 'FIRST_CHECK':
          this.statu = 1
          this.termList = FIRST_DECISION
          this.type = 'FIRST_CHECK'
          break
        case 'final_check':
        case 'FINAL_CHECK':
          this.statu = 2
          this.termList = FINAL_DECISION
          this.type = 'FINAL_CHECK'
          break
      }

      const data = await openAcademic.academicCode(this.code)
      const dataReview = await openAcademic.academicReviewer(data.id, this.type)
      this.reviews = data ? data : {}
      this.reviewerFileList = this.reviews.academicFileList || []
      this.reviews.reviewerList.push({
        firstName: '',
        lastName: '',
        email: ''
      })
      this.journalResponse = data.manuscript ? data.manuscript : {}
      this.reviewsResponse = dataReview ? dataReview : {}
      // data.reviewerBoardMemberIdList = reviewerBoardMemberList
      //   ? reviewerBoardMemberList.map(item => {
      //       return item.id
      //     })
      //   : []
      let flagSign = {}
      let flag = false
      let signReverse = this.reviewsResponse.signList
        ? this.reviewsResponse.signList.slice().reverse()
        : []
      let reviewerDecisionReverse = this.reviewsResponse.reviewerDecisionList
        ? this.reviewsResponse.reviewerDecisionList.slice().reverse()
        : []
      for (let i = 0; i < signReverse.length; i++) {
        let sign = signReverse[i]
        for (let j = 0; j < reviewerDecisionReverse.length; j++) {
          let decision = reviewerDecisionReverse[j]
          if (decision.sign == sign) {
            flagSign = decision
            flag = true
            break
          } else {
            flag = false
          }
        }
        if (flag) {
          break
        }
      }

      if (flagSign) {
        const data = this.reviewsResponse.reviewerList.filter(
          item => item.id === flagSign.personId
        )
        if (data) {
          this.activeData = flagSign
          this.activeData.__index = 0
          this.activeKey[0] = flagSign.personId
          this.activeKey[1] = flagSign.sign
        }
      }
    },

    onChange() {},

    // 文件修改
    async handleUpload(files) {
      const types = [
        'pdf',
        'docx',
        'doc',
        'txt',
        'png',
        'jpg',
        'jpeg',
        'mp4',
        'mp3',
        'html',
        'xml',
        'mov',
        'xls',
        'xlsx',
        'zip',
        'tif',
        'tiff',
        'rtf'
      ]
      if (files.length === 1) {
        const file = files[0]
        let type = file.name.split('.')
        type = type[type.length - 1].toLowerCase()
        if (!types.includes(type)) {
          this.$message.error({
            title: 'Error',
            content: this.LANGUAGE[this.language].isWrongType
          })
          return false
        } else {
          this.addFile(file)
        }
      } else {
        files.forEach(file => {
          let type = file.name.split('.')
          type = type[type.length - 1].toLowerCase()
          if (types.includes(type)) {
            this.addFile(file)
          }
        })
      }
    },
    async addFile(file) {
      const flag = this.reviewerFileList.some(val => {
        if (file.name === val.name) {
          val = {
            name: file.name,
            size: file.size,
            description: '',
            path: '',
            file: file,
            authorShowed: val.authorShowed ? val.authorShowed : true,
            sort: val.sort
          }
          return true
        }
      })
      const path = `publisher/${this.publisherId}/manuscript/${
        this.$route.query.manuscriptId
      }/submit/${help.guid()}`

      this.uploadProgress = {
        current: 0,
        total: this.reviewerFileList.length
      }
      const pro_all = []
      this.loading = true
      if (!flag) {
        this.reviewerFileList.push({
          name: file.name,
          size: file.size,
          // description: '',
          path: '',
          file: file,
          authorShowed: true,
          sort: ''
        })
      }
      this.reviewerFileList.forEach((item, index) => {
        item.sort = item.sort ? item.sort : index
        if (!item.path) {
          pro_all[index] = getUploadConfig(item.file, path).then(res => {
            if (res && !res.includes('err:')) {
              this.uploadProgress.current++
            }
            return res
          })
        } else {
          this.uploadProgress.current++
        }
      })
      const reses = await Promise.all(pro_all)
      this.loading = false
      this.errArr = []
      reses.forEach(item => {
        if (item && item.includes('err:')) {
          this.errArr.push(item.split(':')[1])
        }
      })

      this.reviewerFileList.forEach((item, index) => {
        if (!item.path && reses[index] && !reses[index].includes('err:')) {
          item.path = reses[index]
        }
        item.sort = index
      })

      if (this.errArr.length) {
        this.$message.error(this.LANGUAGE[this.language].uploadFileFail, 5)
        this.uploadProgress = {
          current: 0,
          total: 0
        }
        return
      }
    },

    // 文件列表
    download(item) {
      const file = item
      if (file) {
        const url = file.path
          ? this.domain + '/' + file.path
          : window.URL.createObjectURL(file.file)
        help.download(url, file.name)
      } else {
        zip.zipFile(item, 'author_files.zip')
      }
    },
    del(index) {
      this.$confirm({
        title: 'Are you sure you want to delete this file?',
        content:
          'Please be aware of once this file is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        if (index || index === 0) {
          this.reviewerFileList.splice(index, 1)
        } else {
          this.reviewerFileList = []
        }
        this.$message.success({
          title: 'Success',
          content: 'This file has been deleted!'
        })
      })
    },

    // 保存
    async commit() {
      const data = await openAcademic.academicCode(this.code)
      console.log(data, 'data')
      if (
        [
          'PRE_CHECK_DONE',
          'FIRST_DECISION_DONE',
          'FINAL_DECISION_DONE'
        ].includes(data.status)
      ) {
        // 详情页
        this.$router.push(
          `/email-url/academic-agree/detail?decisionKey=${this.code}&decisionType=${this.decisionType}`
        )
        // location.href=
        return
      } else if (['TERMINATED_BY_EDITOR'].includes(data.status)) {
        this.$router.push(
          `/email-url/invalid-page?code=${this.code}&decisionType=${this.decisionType}`
        )
        return
      }
      let flag = this.$refs['reviews-commit'].validate()
      if (this.reviews.reviewerList) {
        for (let i = 0; i < this.reviews.reviewerList.length; i++) {
          if (
            !this.reviews.reviewerList[i].firstName &&
            !this.reviews.reviewerList[i].lastName &&
            !this.reviews.reviewerList[i].email
          ) {
            this.reviews.reviewerList.splice(i, 1)
          }
        }
        for (let i = 0; i < this.reviews.reviewerList.length; i++) {
          if (
            this.reviews.reviewerList[i].email &&
            !check.email(this.reviews.reviewerList[i].email)
          ) {
            this.$message.error({
              title: 'Error',
              content: 'Please enter the correct email address!'
            })
            return
          }
        }
      }

      this.parmas = Object.assign(this.reviews, {
        manuscriptId: this.$route.query.manuscriptId,
        sign: this.$route.query.sign,
        academicFileList: this.reviewerFileList
        // version:this.
      })
      if (!this.parmas.decisionStatus) {
        this.$message.error({
          title: 'Error',
          content: 'Please select a decision status!'
        })
        return
      }

      if (flag) {
        // console.log(this.parmas, '参数')
        this.parmas.sign = this.parmas.manuscript.sign
        this.parmas.manuscriptId = this.parmas.manuscript.id
        await openAcademic.academicCommit(this.code, this.parmas)
        this.$message.success({
          title: 'Success',
          content: 'Thank you for submitting your decision!'
        })
        // this.$router.push('/academic-menu/external?status=COMPLETED_DECISION')
        location.href = `/email-url/academic-agree/detail?decisionKey=${this.code}&decisionType=${this.decisionType}`
      }
    },

    // 审稿人展开

    togalReport(item, type) {
      item[type] == undefined ? (item[type] = true) : (item[type] = !item[type])
      this.reviewsResponse = JSON.parse(JSON.stringify(this.reviewsResponse))
    },
    // comments to Editor Author
    togalEditor(item, type) {
      item[type] == undefined ? (item[type] = true) : (item[type] = !item[type])
      this.reviewsResponse = JSON.parse(JSON.stringify(this.reviewsResponse))
    },
    // 状态切换
    changeStatus(statu) {
      this.reviews.decisionStatus = statu
      if (this.statu === 1 || this.statu === 2) {
        this.rules.authorNotes[0].required = false
      } else {
        if (['PEER_REVIEW', 'ACCEPT_CURRENT'].includes(statu)) {
          this.rules.authorNotes[0].required = false
        } else {
          this.rules.authorNotes[0].required = true
        }
      }
    },
    showReportDetail(id, sign, index) {
      // 显示审稿报告
      // this.showReport = true
      this.activeKey[0] = id
      this.activeKey[1] = sign
      const tempArr =
        this.reviewsResponse.reviewerDecisionList &&
        this.reviewsResponse.reviewerDecisionList.filter(
          ele => ele.personId === id && sign == ele.sign
        ) &&
        this.reviewsResponse.reviewerDecisionList.filter(
          ele => ele.personId === id && sign == ele.sign
        ).length > 0 &&
        this.reviewsResponse.reviewerDecisionList.filter(ele => {
          return ele.personId === id && sign == ele.sign
        })[0]
      this.activeData = tempArr
      this.activeData.__index = index
    },
    addReviewer() {
      this.reviews.reviewerList.push({
        firstName: '',
        lastName: '',
        email: ''
      })
    },
    cancel() {
      this.showReport = false
    },
    delReviewer(index) {
      this.$confirm({
        title: 'Are you sure you want to delete this data?',
        content:
          'Please be aware of once this data is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        this.reviews.reviewerList.splice(index, 1)
        this.$message.success({
          title: 'Success',
          content: 'This Data has been deleted!'
        })
      })
    },
    showDecision(item) {
      let link = `/email-url/academic-agree/detail?decisionKey=${item.code}&decisionType=${item.decisionType}`
      window.open(link)
    }
  }
}
